import { Typography } from '../../../Typography/typography';
import styles from './EmployerPortalJobDetail.module.css';
export const jobRequirmentUI = (title, description, icon) => {
    return (
        <div className={styles.jobRequirmentUIContainer} style={{ alignItems: "flex-start" }} >
            <div className={styles.iconContainer}>
                <img src={icon} className={styles.requirmentIcon} />
            </div>
            <div>
                <Typography
                    title={title}
                    weight={"600"}
                    fontSize={14}
                />
                <Typography
                    title={description}
                    weight={"400"}
                    fontSize={13}
                />
            </div>
        </div>
    )
}